import Dexie from 'dexie';
import { VoyagePlan } from '../src/models/vessel-planning-model';
import { ScheduleEntry } from '../src/models/types/voyage-schedules-model.types';

export class DraftsDBManager extends Dexie {
 _plans!: Dexie.Table<VoyagePlan, number>;
 _schedules!: Dexie.Table<ScheduleEntry, string>;
 constructor() {
   super('Drafts_VesselDB');
   const { draftVesselDbVersion = 1 } = (<any>window)["appenv"].indexedDBConfig;

   this.version(draftVesselDbVersion).stores({
     plans: '++id',
     schedules: '++id',
   });

   this._plans = this.table('plans');
   this._schedules = this.table('schedules');
 }

 plan = {
   addPlan: async (plan: VoyagePlan) => {
     return await this._plans.put(plan);
   },
   getPlan: async (id: number) => {
     return await this._plans.get(id);
   },
   updatePlan: async (id: number, plan: VoyagePlan) => {
     return await this._plans.update(id, plan);
   },
   getAllPlans: async () => {
     return await this._plans.toArray();
   },
   deletePlan: async (id: number) => {
     return await this._plans.delete(id);
   },
 }

 schedule = {
   addSchedule: async (schedule: ScheduleEntry) => {
     return await this._schedules.put(schedule);
   },
   getSchedule: async (id: string) => {
     return await this._schedules.get(id);
   },
   updateSchedule: async (id: string, schedule: ScheduleEntry) => {
     return await this._schedules.update(id, schedule);
   },
   getAllSchedules: async () => {
     return await this._schedules.toArray();
   },
   deleteSchedule: async (id: string) => {
     return await this._schedules.delete(id);
   },
 }
}

export const getDraftDatabase = (): DraftsDBManager => new DraftsDBManager();